import { render } from "./dp3-list.vue?vue&type=template&id=e2417522"
import script from "./dp3-list.vue?vue&type=script&lang=js"
export * from "./dp3-list.vue?vue&type=script&lang=js"

import "./dp3-list.vue?vue&type=style&index=0&id=e2417522&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__